import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "./app/assets/loader/LoaderAnimation.json";
import { Box } from "@mui/material";
import { connect } from "react-redux";
import "./app-route.scss";

/**
 * Full-screen loader overlay that reacts to global appearance state.
 */
const Loader = connect((state: any) => {
  return {
    isLoading: state.appearance.isLoading,
    attachmentsLoading: state.appearance.attachmentsLoading,
  };
}, null)((props: any) => {
  if (props.isLoading.length || props.attachmentsLoading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor:
            globalThis.location.pathname === "/landing"
              ? "white"
              : "rgba(0, 0, 0, 0.3)",
          zIndex: 2000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Lottie
          animationData={loaderAnimation}
          loop
          style={{ width: 200, height: 200 }}
        />
      </Box>
    );
  }
  return null;
});

const App = (props: any) => {
  /**
   * App route wrapper that injects the Loader and renders children.
   */
  return (
    <>
      <Loader />
      {props?.children}
    </>
  );
};

export default App;
